/* eslint-disable */
import createIcon from '../createIcon';

const IconList = createIcon({
  name: 'icon-list',
  content: '<title>ic_列表</title><defs><rect id="icon-list-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1075.000000, -6656.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(113.000000, 487.000000)"><g transform="translate(464.000000, 0.000000)"><mask id="icon-list-b" fill="currentColor"><use xlink:href="#icon-list-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-list-a"/><path d="M15.5,14.5 L15.5,15.5 L0.5,15.5 L0.5,14.5 L15.5,14.5 Z M15.5,7.5 L15.5,8.5 L0.5,8.5 L0.5,7.5 L15.5,7.5 Z M15.5,0.5 L15.5,1.5 L0.5,1.5 L0.5,0.5 L15.5,0.5 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-list-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconList;
